import { FC } from 'react';

import { Modal } from '@rikstv/play-common/src/components/modal/Modal';
import { useTrailerPlayerStore } from '@rikstv/play-player/src/components/TrailerPlayer/useTrailerPlayerStore';
import { FullScreenPlayer } from '@rikstv/play-player/src/FullScreenPlayer';

import styles from '../StackedEpisodeOrMoviePage.module.css';

export const ModalFullscreenPlayer: FC<{ assetId?: string; onClose: () => void }> = ({ assetId, onClose }) => {
  const setPlayBackgroundTrailer = useTrailerPlayerStore(s => s.setPlayBackgroundTrailer);

  return (
    <Modal
      center
      open={assetId != null}
      onClose={() => {
        onClose();
        setPlayBackgroundTrailer(true);
      }}
      className={styles.playerModal}>
      <FullScreenPlayer
        assetId={assetId}
        onClose={() => {
          onClose();
          //Allow background trailers to play when the modal is closed
          setPlayBackgroundTrailer(true);
        }}
      />
    </Modal>
  );
};
